"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var content_1 = require("@dynamynd/content");

var content_parser_1 = require("@dynamynd/content-parser");

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

exports.SharedModuleNotPurchased = react_1.default.memo(function (_a) {
  var sharingContent = _a.sharingContent;
  return react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(components_lib_1.TitleWithMargin, {
    small: true
  }, "Error"), react_1.default.createElement(content_parser_1.ParsedContent, {
    content: sharingContent.moduleLockedMessage
  }));
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    sharingContent: content_1.sharingContentSelector(state)
  };
};

var connector = react_redux_1.connect(mapStateToProps);
exports.default = connector(exports.SharedModuleNotPurchased);